module.exports = {
	"Insurance Companies": [
		{
			"SL. No.": 1,
			"name": "BUPA International"
		},
		{
			"SL. No.": 2,
			"name": "CIGNA international Corporation"
		},
		{
			"SL. No.": 3,
			"name": "Aetna international Inc."
		},
		{
			"SL. No.": 4,
			"name": "GMC Mednet International Network"
		},
		{
			"SL. No.": 5,
			"name": "AP COMPANIES GLOBAL SOLUTIONS LIMITED"
		},
		{
			"SL. No.": 6,
			"name": "Surgery Pan Asia"
		},
		{
			"SL. No.": 7,
			"name": "Allianz Worldwide Care Limited"
		},
		{
			"SL. No.": 8,
			"name": "Meera Rescue Services Pvt. Ltd."
		},
		{
			"SL. No.": 9,
			"name": "Asia Medical Assistance Pvt. Limited"
		},
		{
			"SL. No.": 11,
			"name": "Emergency Assistance Japan (Singapore) Pte. Ltd."
		},
		{
			"SL. No.": 12,
			"name": "Quality Health Management, L.L.C (QHM)"
		},
		{
			"SL. No.": 13,
			"name": "ASIAN TRAVEL AND MEDICAL SERVICES, INDIA"
		},
		{
			"SL. No.": 14,
			"name": "Q Life & Medical Insurance Company LLC"
		},
		{
			"SL. No.": 15,
			"name": "Allianz Global Assistance (AGA) Services (India) Private Limited"
		},
		{
			"SL. No.": 16,
			"name": "World Health Organization"
		},
		{
			"SL. No.": 17,
			"name": "Euro-Center (Thailand) Co. Ltd."
		},
		{
			"SL. No.": 18,
			"name": "Europ Assistance-Global Corporate Solutions (GCP)"
		},
		{
			"SL. No.": 19,
			"name": "HSBC India"
		},
		{
			"SL. No.": 20,
			"name": "PARAMOUNT HEALTHCARE MANAGEMENT PVT. LTD."
		},
		{
			"SL. No.": 21,
			"name": "Arcofemi Healthcare Limited"
		},
		{
			"SL. No.": 22,
			"name": "MetLife Alico"
		},
		{
			"SL. No.": 23,
			"name": "Delta Life Insurance Company Limited."
		},
		{
			"SL. No.": 24,
			"name": "Pragati Life Insurance Limited."
		},
		{
			"SL. No.": 25,
			"name": "Pragati Insurance Limited"
		},
		{
			"SL. No.": 26,
			"name": "RUPALI LIFE INSURANCE COMPANY LIMITED."
		},
		{
			"SL. No.": 27,
			"name": "Reliance Insurance Limited"
		},
		{
			"SL. No.": 28,
			"name": "PROVATI INSURANCE COMPANY LIMITED"
		},
		{
			"SL. No.": 29,
			"name": "FAR EAST ISLAMI LIFE INSURANCE COMPANY LIMITED (DIRECTOR,STAFF & DEPENDANTS)"
		},
		{
			"SL. No.": 30,
			"name": "FAR EAST ISLAMI LIFE INSURANCE COMPANY LIMITED (CLIENTS)"
		},
		{
			"SL. No.": 31,
			"name": "Protective Islami Life Insurance"
		},
		{
			"SL. No.": 32,
			"name": "Green Delta Insurance Company Limited"
		},
		{
			"SL. No.": 33,
			"name": "GUARDIAN LIFE INSURANCE LIMITED."
		}
	],
	"Multinational Companies": [
		{
			"SL. No.": 1,
			"name": "Unilever Bangladesh Limited"
		},
		{
			"SL. No.": 2,
			"name": "Huawei Technologies (Bangladesh) Limited"
		},
		{
			"SL. No.": 3,
			"name": "MULTINATIONAL OSG SERVICE BANGLADESH (PVT.) LIMITED"
		},
		{
			"SL. No.": 4,
			"name": "NEPC Consortium Power Limited"
		},
		{
			"SL. No.": 5,
			"name": "IKEA Trading (Hongkong) Limited"
		},
		{
			"SL. No.": 6,
			"name": "Japan Internation co-operation Agency(JICA) Bangladesh Office"
		},
		{
			"SL. No.": 7,
			"name": "International Organization For Migration"
		},
		{
			"SL. No.": 8,
			"name": "Korean International Co-operation Agency (KOICA)"
		},
		{
			"SL. No.": 9,
			"name": "Netherlands Recreation Centre"
		},
		{
			"SL. No.": 10,
			"name": "SEAF Ventures Management LLC"
		},
		{
			"SL. No.": 11,
			"name": "Grameen Phone Ltd."
		},
		{
			"SL. No.": 12,
			"name": "Banglalink Digital Communications Limited"
		},
		{
			"SL. No.": 13,
			"name": "Airtel Bangladesh Limited"
		},
		{
			"SL. No.": 14,
			"name": "ROBI (Axita Bangladesh Limited)"
		},
		{
			"SL. No.": 15,
			"name": "East Compeace Smart Card (Bangladesh) Limited"
		},
		{
			"SL. No.": 16,
			"name": "Sumitomo Corporation Asia PTE . Limited"
		},
		{
			"SL. No.": 17,
			"name": "International Beverages Private Limited (IBPL)"
		},
		{
			"SL. No.": 18,
			"name": "DHL EXPRESS"
		},
		{
			"SL. No.": 19,
			"name": "Singer Bangladesh Limited"
		},
		{
			"SL. No.": 20,
			"name": "Inter Laboratory Test - ICDDRB"
		},
		{
			"SL. No.": 21,
			"name": "Nestle Bangladesh Limited"
		},
		{
			"SL. No.": 22,
			"name": "National Energy Services Limited (NESL)"
		},
		{
			"SL. No.": 23,
			"name": "Lafarge Surma Cement Limited"
		},
		{
			"SL. No.": 24,
			"name": "COATS Bangladesh Limited"
		},
		{
			"SL. No.": 25,
			"name": "Nokia Siemens Networks Bangladesh Limited"
		},
		{
			"SL. No.": 26,
			"name": "DHL Global Forwarding (Bangladesh) Limited"
		},
		{
			"SL. No.": 27,
			"name": "C & A Sourcing International Limited, Bangladesh liaison office"
		},
		{
			"SL. No.": 28,
			"name": "YKK Bangladesh Pte Ltd"
		},
		{
			"SL. No.": 29,
			"name": "Eminence"
		},
		{
			"SL. No.": 30,
			"name": "CEAT AKKHAN LTD"
		},
		{
			"SL. No.": 31,
			"name": "Covanta Bangladesh Operating Ltd"
		},
		{
			"SL. No.": 32,
			"name": "MAERSK Bangladesh Ltd. / APM Global Logistics Bangladesh Ltd."
		},
		{
			"SL. No.": 33,
			"name": "SHIMIZU CORPORATION"
		},
		{
			"SL. No.": 34,
			"name": "Reckitt Benckiser (Bangladesh)"
		},
		{
			"SL. No.": 35,
			"name": "Korean community in Bangladesh"
		},
		{
			"SL. No.": 36,
			"name": "Santos Sangu Field Limited"
		},
		{
			"SL. No.": 37,
			"name": "The World Bank"
		},
		{
			"SL. No.": 38,
			"name": "Katalyst"
		},
		{
			"SL. No.": 39,
			"name": "Huawei Technologies Bangladesh Limited"
		},
		{
			"SL. No.": 40,
			"name": "Haripur Power Limited"
		},
		{
			"SL. No.": 41,
			"name": "ESPIRIT DE CORP (FAR EAST) LIMITED"
		},
		{
			"SL. No.": 42,
			"name": "GE HEALTHCARE LIMITED"
		},
		{
			"SL. No.": 43,
			"name": "Radisson Water Garden Hotel Dhaka"
		},
		{
			"SL. No.": 44,
			"name": "Karnaphuli Fertilizer Company Limited (KAFCO)"
		},
		{
			"SL. No.": 45,
			"name": "SGS Bangladesh Limited"
		},
		{
			"SL. No.": 46,
			"name": "SIEMENS BANGLADESH LIMITED"
		},
		{
			"SL. No.": 47,
			"name": "SABINCO"
		},
		{
			"SL. No.": 48,
			"name": "Malaysia Airlines"
		},
		{
			"SL. No.": 49,
			"name": "RING Bangladesh"
		},
		{
			"SL. No.": 50,
			"name": "QTEC DHAKA LAB"
		},
		{
			"SL. No.": 51,
			"name": "Itochu Corporation"
		},
		{
			"SL. No.": 52,
			"name": "Accenture"
		},
		{
			"SL. No.": 53,
			"name": "Li & Fung (Bangladesh) Limited"
		},
		{
			"SL. No.": 54,
			"name": "LM ERICSSON BANGLADESH LIMITED"
		},
		{
			"SL. No.": 55,
			"name": "British American Tobacco Bangladesh (BATB)"
		},
		{
			"SL. No.": 56,
			"name": "Philip Morris India Services S.A."
		},
		{
			"SL. No.": 57,
			"name": "Saas Aviation Services"
		},
		{
			"SL. No.": 58,
			"name": "GS Engineering & Construction Corporation"
		},
		{
			"SL. No.": 59,
			"name": "Dhaka Regency Hotel & Resort Limited"
		},
		{
			"SL. No.": 60,
			"name": "Toyota Tsusho Corporation"
		},
		{
			"SL. No.": 61,
			"name": "New Castle College And University of New Castle (USA)"
		},
		{
			"SL. No.": 62,
			"name": "Japatech Cleaning Service Limited"
		},
		{
			"SL. No.": 63,
			"name": "BUREAU VERITAS CONSUMER PRODUCTS SERVICES (BD) LIMITED"
		},
		{
			"SL. No.": 64,
			"name": "China Machinery Engineering Corporation"
		},
		{
			"SL. No.": 65,
			"name": "The International Maize and Wheat Improvement Center (CIMMYT)"
		},
		{
			"SL. No.": 66,
			"name": "CEMEX CEMENT (BANGLADESH) LIMITED"
		},
		{
			"SL. No.": 67,
			"name": "Tetra Pak"
		},
		{
			"SL. No.": 68,
			"name": "Mitsui & Co. (Asia Pacific) Pte. Ltd. Dhaka Branch"
		},
		{
			"SL. No.": 69,
			"name": "ALLIANCE HOLDINGS LIMITED & ASSOCITE COMPANIES"
		},
		{
			"SL. No.": 70,
			"name": "KGS Sourcing Limited (Bangladesh Liaison Office)"
		},
		{
			"SL. No.": 71,
			"name": "DRAGON AIR & CATHAY PACIFIC AIRWAYS"
		},
		{
			"SL. No.": 72,
			"name": "THE INSTITUTE OF COST AND MANAGEMENT ACCOUNTANTS OF BANGLADESH (ICMAB)"
		},
		{
			"SL. No.": 73,
			"name": "Emirates"
		},
		{
			"SL. No.": 74,
			"name": "SAUDIA MEDICAL SERVICES, SAUDI ARABIAN AIRLINES (Parents and Dependants of Crew)"
		},
		{
			"SL. No.": 75,
			"name": "Foster Wheeler (Thailand)"
		},
		{
			"SL. No.": 76,
			"name": "ORBIS INTERNATIONAL"
		},
		{
			"SL. No.": 77,
			"name": "Phoenix Finance & Investment Limited"
		},
		{
			"SL. No.": 78,
			"name": "HEALIX INTERNATIONAL LIMITED"
		},
		{
			"SL. No.": 79,
			"name": "MAXWELL STAMP LIMITED"
		},
		{
			"SL. No.": 80,
			"name": "Berger Paints Bangladesh Limited"
		},
		{
			"SL. No.": 81,
			"name": "The Fred Hollows Foundation"
		},
		{
			"SL. No.": 82,
			"name": "Youngone Hi-Tech Sportswear Industries Limited"
		},
		{
			"SL. No.": 83,
			"name": "Puls Trading Far East Limited"
		},
		{
			"SL. No.": 84,
			"name": "KEC International Limited"
		},
		{
			"SL. No.": 85,
			"name": "KEPCO PLANT SERVICE & ENGINEERING COMPANY LIMITED & SUMMIT MEGHNAGHAT POWER COMPANY LIMITED"
		},
		{
			"SL. No.": 86,
			"name": "Godrej Household Products (BD) Pvt. Limited"
		}
	],
	"Embassies": [
		{
			"SL. No.": 1,
			"name": "U.S Embassy, Dhaka"
		},
		{
			"SL. No.": 2,
			"name": "Australian High Commission Dhaka"
		},
		{
			"SL. No.": 3,
			"name": "Embassy of the Kingdom of the Netherlands"
		},
		{
			"SL. No.": 4,
			"name": "European Union Delegation to Bangladesh"
		},
		{
			"SL. No.": 5,
			"name": "Embassy of Japan, Dhaka"
		},
		{
			"SL. No.": 6,
			"name": "The Embassy of Switzerland"
		},
		{
			"SL. No.": 7,
			"name": "Embassy of Sweden Dhaka"
		},
		{
			"SL. No.": 8,
			"name": "Embassy of the State of Qatar Dhaka"
		},
		{
			"SL. No.": 9,
			"name": "Embassy of the State of Kuwait in Dhaka"
		},
		{
			"SL. No.": 10,
			"name": "Embassy of the State of Palestine"
		},
		{
			"SL. No.": 11,
			"name": "High Commission of Brunei Darussalam"
		},
		{
			"SL. No.": 12,
			"name": "High Commission Of Malaysia"
		},
		{
			"SL. No.": 13,
			"name": "Embassy of the DPR of Korea, Dhaka"
		},
		{
			"SL. No.": 14,
			"name": "Embassy of The People's Republic of China"
		},
		{
			"SL. No.": 15,
			"name": "Korean Embassy"
		},
		{
			"SL. No.": 16,
			"name": "High Commission of Canada, Dhaka"
		},
		{
			"SL. No.": 17,
			"name": "British High Commission Medical Centre (Elizabeth House) British High Commission Dhaka"
		},
		{
			"SL. No.": 18,
			"name": "Consultant of the Republic of Singapore, Dhaka"
		},
		{
			"SL. No.": 19,
			"name": "Royal Bhutanese Embassy"
		},
		{
			"SL. No.": 20,
			"name": "Embassy of the Federal Republic of Germany"
		},
		{
			"SL. No.": 21,
			"name": "Embassy of the Republic of Turkey"
		},
		{
			"SL. No.": 22,
			"name": "British High Commission Medical Centre (Elizabeth House) British High Commission, Dhaka"
		}
	],
	"Other Companies": [
		{
			"SL. No.": 1,
			"name": "The Hongkong And Shanghai Banking Corporation Limited (HSBC)"
		},
		{
			"SL. No.": 2,
			"name": "Linde Bangladesh Limited"
		},
		{
			"SL. No.": 3,
			"name": "Rahimafrooz(Bangladesh)Limited(Batteries Ltd.,Distribution Ltd.,Superstores Ltd.,Energy Services Ltd.,CNG Ltd.Renewable Energy Ltd.,Excel Resources Ltd.,Globatt Ltd.,Arzed Ltd., Grayfeb Ltd.)"
		},
		{
			"SL. No.": 4,
			"name": "Independent Television Limited"
		},
		{
			"SL. No.": 5,
			"name": "BS GROUP"
		},
		{
			"SL. No.": 6,
			"name": "IPDC"
		},
		{
			"SL. No.": 8,
			"name": "Dhaka Electric Supply Company Limited (DESCO)"
		},
		{
			"SL. No.": 10,
			"name": "4 - M Associates"
		},
		{
			"SL. No.": 11,
			"name": "Bank Asia"
		},
		{
			"SL. No.": 12,
			"name": "Gemcon Group"
		},
		{
			"SL. No.": 13,
			"name": "Paradise Group"
		},
		{
			"SL. No.": 14,
			"name": "Genuity System Ltd"
		},
		{
			"SL. No.": 15,
			"name": "Proshika"
		},
		{
			"SL. No.": 16,
			"name": "Newtop Trading Limited"
		},
		{
			"SL. No.": 17,
			"name": "Bangladesh Corrugated Carton & Accessories Manufacturers & Exporters Association (BCCAMEA)"
		},
		{
			"SL. No.": 18,
			"name": "BSRM Group of Companies (BSRM Steel Ltd,Bangladesh Steel Re-Rolling)"
		},
		{
			"SL. No.": 19,
			"name": "North South University"
		},
		{
			"SL. No.": 20,
			"name": "Partners in Population and Development (PPD)"
		},
		{
			"SL. No.": 21,
			"name": "Energypac Power Generation Limited"
		},
		{
			"SL. No.": 22,
			"name": "Bangladesh Olympic Association (BOA)"
		},
		{
			"SL. No.": 23,
			"name": "NAK Fashion & Textiles Limited"
		},
		{
			"SL. No.": 24,
			"name": "The City Bank Limited"
		},
		{
			"SL. No.": 25,
			"name": "Grace International School"
		},
		{
			"SL. No.": 26,
			"name": "Saaol Bangladesh"
		},
		{
			"SL. No.": 27,
			"name": "Premier LP Gas Limited"
		},
		{
			"SL. No.": 28,
			"name": "Uttara Group of Companies (Uttara motor, Automobiles, Automobiles Mnufactures, Tyre retreading co. apparels, Honkong JVC, services, menoka motors)"
		},
		{
			"SL. No.": 29,
			"name": "Integrated Security Services Limited (ISSL)"
		},
		{
			"SL. No.": 30,
			"name": "GSB International Consultant"
		},
		{
			"SL. No.": 31,
			"name": "Meghnaghat Power Limited"
		},
		{
			"SL. No.": 32,
			"name": "Gulf Oil Bangladesh Limited"
		},
		{
			"SL. No.": 33,
			"name": "Bangladesh Power Development Board (BPDB)"
		},
		{
			"SL. No.": 34,
			"name": "Compassion International Bangladesh"
		},
		{
			"SL. No.": 35,
			"name": "Ascott The Residence"
		},
		{
			"SL. No.": 36,
			"name": "Gulshan Society"
		},
		{
			"SL. No.": 37,
			"name": "Ideal Plus"
		},
		{
			"SL. No.": 38,
			"name": "Total E&P Bangladesh"
		},
		{
			"SL. No.": 39,
			"name": "American International University Bangladesh (AIUB)"
		},
		{
			"SL. No.": 40,
			"name": "Viyellatex Group (Garments, Fabrics, Spinning, Printing, Interfab Shirt, Fashion Plastic)"
		},
		{
			"SL. No.": 41,
			"name": "Jalal Ahmed Spinning Mills Ltd"
		},
		{
			"SL. No.": 42,
			"name": "Madina Hazz Kafilla & Oversease Ltd."
		},
		{
			"SL. No.": 43,
			"name": "Bashundhara Group"
		},
		{
			"SL. No.": 45,
			"name": "Rotaract District Organization"
		},
		{
			"SL. No.": 46,
			"name": "Prime Bank Limited"
		},
		{
			"SL. No.": 47,
			"name": "Jamuna Investment & Commerce Multipurpose Co-operative Society Ltd."
		},
		{
			"SL. No.": 48,
			"name": "Nokon Limited"
		},
		{
			"SL. No.": 49,
			"name": "Schlumberger Seaco Inc."
		},
		{
			"SL. No.": 50,
			"name": "IDLC Finance Limited"
		},
		{
			"SL. No.": 51,
			"name": "Lake View Clinic"
		},
		{
			"SL. No.": 52,
			"name": "BRAC Bank Limited"
		},
		{
			"SL. No.": 53,
			"name": "Gulshan Youth Club"
		},
		{
			"SL. No.": 54,
			"name": "United Commercial Bank Ltd. (UCBL)"
		},
		{
			"SL. No.": 55,
			"name": "NDB Capital Limited"
		},
		{
			"SL. No.": 56,
			"name": "Star Point Rewards Bangladesh Limited & Healthcare Privilege"
		},
		{
			"SL. No.": 57,
			"name": "Bangladesh Association of International Recruiting Agencies (BAIRA)"
		},
		{
			"SL. No.": 58,
			"name": "ICDDR,B Dhaka Hospital"
		},
		{
			"SL. No.": 59,
			"name": "Canadian International School, Dhaka"
		},
		{
			"SL. No.": 61,
			"name": "Bangladesh Bank"
		},
		{
			"SL. No.": 63,
			"name": "Bank Alfalh Limited"
		},
		{
			"SL. No.": 65,
			"name": "Rahman Rahman Huq"
		},
		{
			"SL. No.": 67,
			"name": "NAVANA Group"
		},
		{
			"SL. No.": 68,
			"name": "DHAKA BANK LIMITED"
		},
		{
			"SL. No.": 69,
			"name": "Concord Group of Companies"
		},
		{
			"SL. No.": 70,
			"name": "Bashundhara Amusement Park LTD."
		},
		{
			"SL. No.": 71,
			"name": "The Westin Dhaka"
		},
		{
			"SL. No.": 72,
			"name": "Baridhara DOHS Association"
		},
		{
			"SL. No.": 73,
			"name": "Bangladesh - Malaysia Chamber of Commerce and Industry"
		},
		{
			"SL. No.": 74,
			"name": "BAY DEVELOPMENTS"
		},
		{
			"SL. No.": 75,
			"name": "Transcom Group"
		},
		{
			"SL. No.": 76,
			"name": "World Vision Bangladesh"
		},
		{
			"SL. No.": 77,
			"name": "Gulshan Group Clinic"
		},
		{
			"SL. No.": 78,
			"name": "Sheraton Hotel"
		},
		{
			"SL. No.": 79,
			"name": "Heidelbergcement Bangladesh Ltd"
		},
		{
			"SL. No.": 80,
			"name": "Protishabda Communications Ltd"
		},
		{
			"SL. No.": 81,
			"name": "Renaissance Digonto Unmochon Foundation"
		},
		{
			"SL. No.": 82,
			"name": "NASSA Group"
		},
		{
			"SL. No.": 83,
			"name": "Mercantile Bank Limited"
		},
		{
			"SL. No.": 84,
			"name": "Creative Consulting (Malaysian & China Student Visa Processing Firm)"
		},
		{
			"SL. No.": 85,
			"name": "PROAMS"
		},
		{
			"SL. No.": 86,
			"name": "International Turkish Hope School"
		},
		{
			"SL. No.": 87,
			"name": "Expressions Limited"
		},
		{
			"SL. No.": 88,
			"name": "Hotel Agrabad Chittagong"
		},
		{
			"SL. No.": 89,
			"name": "Sunshine Education Group (SEG)"
		},
		{
			"SL. No.": 90,
			"name": "Index Group"
		},
		{
			"SL. No.": 91,
			"name": "GRAMEEN TELECOM TRUST"
		},
		{
			"SL. No.": 92,
			"name": "BAY FOOTWEAR LIMITED"
		},
		{
			"SL. No.": 93,
			"name": "FIRST SECURITY ISLAMI CAPITAL & INVESTMENT LIMITED"
		},
		{
			"SL. No.": 94,
			"name": "Shakti Foundation"
		},
		{
			"SL. No.": 95,
			"name": "ABB Limited"
		},
		{
			"SL. No.": 96,
			"name": "Family Health Practice"
		},
		{
			"SL. No.": 97,
			"name": "National Bank Limited"
		},
		{
			"SL. No.": 98,
			"name": "Nitol-Niloy Group"
		},
		{
			"SL. No.": 99,
			"name": "Bengal Glass"
		},
		{
			"SL. No.": 100,
			"name": "HABIB BANK LIMITED"
		},
		{
			"SL. No.": 101,
			"name": "Sangen International (Embassy of China Visa Applicant)"
		},
		{
			"SL. No.": 102,
			"name": "Premier Club Member of Dhaka Regency Hotel & Resort Limited"
		},
		{
			"SL. No.": 103,
			"name": "United Maritime Academy"
		},
		{
			"SL. No.": 104,
			"name": "PFI Securities Limited"
		},
		{
			"SL. No.": 105,
			"name": "Azim Group of Companies"
		},
		{
			"SL. No.": 106,
			"name": "Building Technology & Ideas Limited"
		},
		{
			"SL. No.": 107,
			"name": "British Bangladesh Chamber of Commerce U.K"
		},
		{
			"SL. No.": 108,
			"name": "INTRACO GROUP"
		},
		{
			"SL. No.": 109,
			"name": "Sydney International School (SIS)"
		},
		{
			"SL. No.": 110,
			"name": "Unique Group of Companies Limited"
		},
		{
			"SL. No.": 111,
			"name": "Beximco Chemical Division (Beximco Pharmaceuticals Ltd, Pharmatek Chemicals Ltd, I & I Service, Ltd Bangladesh Antibiotic Ltd, Shuktara Printers Ltd.)"
		},
		{
			"SL. No.": 112,
			"name": "FCI (BD) Limited"
		},
		{
			"SL. No.": 113,
			"name": "Talisman Limited"
		},
		{
			"SL. No.": 114,
			"name": "Hotel Holiday Villagram"
		},
		{
			"SL. No.": 116,
			"name": "Social Islami Bank Limited"
		},
		{
			"SL. No.": 117,
			"name": "Bangla Trac Group"
		},
		{
			"SL. No.": 118,
			"name": "BAY OF BENGAL INITIATIVE FOR MULTI-SECTORAL TECHNICAL AND ECONOMIC COOPERATION (BIMSTEC)"
		},
		{
			"SL. No.": 120,
			"name": "BEXIMCO LIMITED, TEXTILES DIVISION"
		},
		{
			"SL. No.": 121,
			"name": "Bengal Group of Industries (RTV, Bengal Plastic, Pipe, Polymer, Adhesive, Solar, Poly Pack, Overseas, Concept & Holdings)"
		},
		{
			"SL. No.": 122,
			"name": "Moon Hospital Limited"
		},
		{
			"SL. No.": 123,
			"name": "R-Three Corporation (Embassy of China Visa Applicant)"
		},
		{
			"SL. No.": 124,
			"name": "HT Global (Embassy of China Visa Applicant)"
		},
		{
			"SL. No.": 125,
			"name": "Bhuiah Construction Narayanganj"
		},
		{
			"SL. No.": 126,
			"name": "Meridian Group"
		},
		{
			"SL. No.": 127,
			"name": "EXPORT IMPORT BANK OF BANGLADESH LIMITED (EXIM BANK)"
		},
		{
			"SL. No.": 128,
			"name": "Doreen Group (Seven Horse Cement, Doreen Developments, Doreen Engineering & Construction, Doreen Power, Doreen RMG & Textiles)"
		},
		{
			"SL. No.": 129,
			"name": "Cox'sbazar Medical Campaign"
		},
		{
			"SL. No.": 130,
			"name": "Standard Group"
		},
		{
			"SL. No.": 131,
			"name": "Seema Rob"
		},
		{
			"SL. No.": 132,
			"name": "ZARIN CONSULTING (SINGAPORE)"
		},
		{
			"SL. No.": 133,
			"name": "Union Bank Limited"
		},
		{
			"SL. No.": 134,
			"name": "Prime Bank Limited Card Holder"
		},
		{
			"SL. No.": 135,
			"name": "United Group Waiters & Cooks"
		},
		{
			"SL. No.": 136,
			"name": "NTPC Limited (A Govt. of India Enterprise)"
		},
		{
			"SL. No.": 137,
			"name": "M & J Group"
		},
		{
			"SL. No.": 138,
			"name": "Bangladesh Export Import Company (BEXIMCO) IT Limited"
		},
		{
			"SL. No.": 139,
			"name": "Rangs Group (DHS Motors Ltd, Rangs Ltd, Rangs Motors Ltd, Rancon Motors Ltd, Rancon Automobiles Ltd, Rangs Workshop Ltd, Rangs Properties Ltd, Rancon Distributions Ltd, Rancon)"
		},
		{
			"SL. No.": 140,
			"name": "BEXIMCO IT (BOL)"
		},
		{
			"SL. No.": 141,
			"name": "The Daily Kaler Kantho"
		},
		{
			"SL. No.": 142,
			"name": "AUKO - TEX GROUP"
		},
		{
			"SL. No.": 143,
			"name": "RAK CERAMICS (BD) LIMITED"
		},
		{
			"SL. No.": 144,
			"name": "KALLOL GROUP OF COMPANIES"
		},
		{
			"SL. No.": 145,
			"name": "UNITED FINANCE LIMITED"
		},
		{
			"SL. No.": 146,
			"name": "First Security Islami Bank Limited"
		},
		{
			"SL. No.": 147,
			"name": "Apex Adelchi Footwear Limited"
		},
		{
			"SL. No.": 148,
			"name": "Abul Khair Group"
		},
		{
			"SL. No.": 149,
			"name": "Bangladesh Edible Oil Limited (BEOL)"
		},
		{
			"SL. No.": 150,
			"name": "SHAHABUDDIN MEDICAL COLLEGE HOSPITAL"
		},
		{
			"SL. No.": 151,
			"name": "Embassy of the Russian Federation in the People's Republic of Bangladesh"
		},
		{
			"SL. No.": 152,
			"name": "Observe (Embassy of China Visa Applicant)"
		},
		{
			"SL. No.": 153,
			"name": "Edison Group"
		},
		{
			"SL. No.": 154,
			"name": "Embassy of Nepal, Dhaka"
		},
		{
			"SL. No.": 155,
			"name": "Glaxosmithkline Bangladesh Limited"
		},
		{
			"SL. No.": 156,
			"name": "Citibank N.A."
		},
		{
			"SL. No.": 157,
			"name": "Association of Travel Agents of Bangladesh (ATAB)"
		},
		{
			"SL. No.": 158,
			"name": "Japan-Bangladesh Medical Association (JBMA)"
		},
		{
			"SL. No.": 159,
			"name": "Khulna Information Centre, UHL"
		},
		{
			"SL. No.": 160,
			"name": "Bangladesh - Turkish Group"
		},
		{
			"SL. No.": 161,
			"name": "NRB GLOBAL BANK LTD"
		},
		{
			"SL. No.": 162,
			"name": "RUPALI LIFE INSURANCE COMPANY LIMITED (Staffs & Dependants)"
		},
		{
			"SL. No.": 163,
			"name": "BAYER CROPSCIENCE LIMITED BANGLADESH"
		},
		{
			"SL. No.": 164,
			"name": "AB BANK LIMITED"
		},
		{
			"SL. No.": 167,
			"name": "MHADI SUPPORT SERVICES LIMITED"
		},
		{
			"SL. No.": 168,
			"name": "ASK Overseas Medical Department"
		},
		{
			"SL. No.": 169,
			"name": "MIDLAND BANK LIMITED (VISA Platinum Credit Card Holders)"
		},
		{
			"SL. No.": 170,
			"name": "MUTUAL TRUST BANK LIMITED."
		},
		{
			"SL. No.": 171,
			"name": "SCB (VISA/ Master Signature, Platinum Credit & Debit Card Holders Only)"
		},
		{
			"SL. No.": 172,
			"name": "Ibrahim Medinet Premier Services (IMPS)"
		},
		{
			"SL. No.": 173,
			"name": "Kleider Sourcing Limited"
		},
		{
			"SL. No.": 174,
			"name": "FX Import Hong Kong Limited"
		},
		{
			"SL. No.": 175,
			"name": "Anand Fashions International LLC"
		},
		{
			"SL. No.": 176,
			"name": "Zamira Fashions Limited"
		},
		{
			"SL. No.": 177,
			"name": "Simple Approach Limited"
		},
		{
			"SL. No.": 178,
			"name": "Poeticgem International Limited"
		},
		{
			"SL. No.": 179,
			"name": "Krayons Sourcing Limited"
		},
		{
			"SL. No.": 180,
			"name": "Bengal Communications Limited"
		},
		{
			"SL. No.": 181,
			"name": "NATIONAL CREDIT AND COMMERCE BANK LIMITED (NCC BANK LTD.)"
		},
		{
			"SL. No.": 182,
			"name": "Norwest Industries Limited"
		},
		{
			"SL. No.": 183,
			"name": "Industrial and Infrastructure Development Finance Company Limited (IIDFC)"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./public/assets/data/table_data.json
// module id = 860
// module chunks = 0